export const setDataLayerMkt = (event: string, data: any) => {
  const isDataSaved =
    window.hasOwnProperty("dataLayerMkt") &&
    window.dataLayerMkt.find(item => item.event === event && item.products === data);

  if (data && !isDataSaved) {
    window.dataLayerMkt.push({
      event: event,
      products: data,
      timestamp: new Date().toISOString()
    });
  }
};
